export default __webpack_public_path__ + "static/media/pinterest.5ea13856.svg";